<template>
  <div class="animated fadeIn vendorrmas--vendorrmas-list">
    <fixed-header
      title="Vendor RMAs List"
      :records="pageInfo.totalItems"
      hideBackBtn
      hideNewOfferBtn
    >
      <add-vrma class="mr-2" v-if="checkClaim(CAN_ADD_VENDOR_RETURNS)"/>
    </fixed-header>

    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Status" class="mr-2">
            <b-form-select v-model="filters.statusId" @change="onSearch">
              <option v-for="option in sortSelect(rmaStatuses)" :key="option.name" :value="option.id">
                {{option.name}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="RMA Number" class="mr-2">
            <b-form-input v-model="filters.rmaNo" @input="onSearch" size="sm"/>
          </b-form-group>
          <b-form-group label="Purchase Order Number" class="mr-2">
            <b-form-input v-model="filters.poNumber" @input="onSearch" size="sm"/>
          </b-form-group>
          <b-form-group label="Vendor" class="mr-2">
            <b-form-input v-model="filters.companyName" @input="onSearch" size="sm"/>
          </b-form-group>
          <b-form-group label="Needs auth" class="mr-2" style="margin-bottom: 5px;">
            <b-form-checkbox v-model="filters.needsAuthorization"
                             :indeterminate.sync="filters.needsAuthorization == null" @input="onSearch"/>
          </b-form-group>
          <b-form-group label="Buyer" class="mr-2">
            <!-- <b-form-input v-model="filters.salesRep" size="sm" @input="onSearch"  /> -->
            <b-form-select v-model="filters.salesRep" @change="onSearch">
              <option :value="null">All</option>
              <option
                v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                :key="indexRep"
                :value="selectRep.id"
              >{{ selectRep.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <date-range-picker :dateFrom="filters.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
          <b-button class="mr-2" size="sm" @click="clearFilter">Clear</b-button>
        </div>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :canEdit="checkClaim(CAN_EDIT_VENDOR_RETURNS)"
          :canDelete="checkClaim(CAN_DELETE_VENDOR_RETURNS)"
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="onEdit"
          :onDelete="onDelete"
          :handleRowClick="onRowClick"
          :styleCustom="'height: 335px'"
          @getData="onGetData"
        />
      </div>

    </div>
    <b-card>
      <b-tabs>
        <b-tab active title="Vendor RMA Items">
          <vendor-rma-lines :vendorrmaId="selectedRowItemId" @showEdit="showEditLine"/>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- RMA Add Part Modal -->
    <vrma-po-line :isAddPart="false" :vrmaPoLine="onEditRMAPart" />
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import { debounce } from 'lodash';

  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import AddVrma from './components/add';
  import VendorRmaLines from './components/VendorrmaLines';
  import VrmaPoLine from '@/pages/Vendorrmas/components/VrmaPoLine';
  import { GRID_PAGE_SIZES, GRID_ID, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';
  import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';

  export default {
    components: {
      FixedHeader,
      AddVrma,
      VendorRmaLines,
      GridSettings,
      GridComponent,
      VrmaPoLine,
      DateRangePicker,
    },
    metaInfo: () => ({
      title: 'Vendorrmas',
    }),
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.VENDORRMAS,
        pageable: {
          pageSizes: GRID_PAGE_SIZES,
        },
        rmaStatuses: [
          { id: null, name: 'All' },
          { id: 230, name: 'Closed' },
          { id: 229, name: 'Open' },
          { id: 228, name: 'Pending' },
        ],
        selectedRowItemId: 0,
        onEditRMAPart: {},
        modalId: 'rma-poline-modal',
      };
    },
    computed: {
      ...mapGetters('vendorrmas', [
        'vrmasList',
        'vendorrma',
        'pageInfo',
        'filters',
        'lastOpenedId',
      ]),
      ...mapGetters('account', ['gridSettingsById']),
      ...mapState('salesReps', ['salesReps']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        if (this.vrmasList == undefined || !this.vrmasList.length) return [];
        return this.vrmasList.map((vendorrma) => ({ ...vendorrma, selected: vendorrma.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapMutations('vendorrmas', ['setItem']),
      ...mapActions('vendorrmas', ['getAll', 'sortGrid', 'getPage', 'search', 'select', 'deleteVrma', 'onUpdateVRMALine']),
      ...mapActions('account', ['saveGridSettings']),
      ...mapActions('salesReps', ['getSalesReps']),
      async onGetData(params) {
        await this.getAll(params);
      },
      onSearch: debounce(function(data = false) {
        if (typeof data === 'object') {
          Object.assign(this.filters, data);
        }
        this.search(this.filters);
      }, SEARCH_DEBOUNCE_TIME),

      clearFilter(callSearch = true) {
        this.clearObject(this.filters);
        if (callSearch) {
          this.search(this.filters);
        }
      },
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
      },
      onEdit(row) {
        this.setItem({ resource: 'lastOpenedId', payload: row.id });
        this.$router.push({
          name: 'vendorrmas.edit',
          params: { id: row.id },
        });
      },
      async onDelete(vrma) {
        this.selectedRowItemId = vrma.id;
        const deleteConfirmed = await this.openConfirmBox({ message: `Are you sure you want to delete Vendor RMA #${vrma.id}?` });
        if (deleteConfirmed) {
          const respose = await this.deleteVrma(vrma.id);

          if (response != undefined && response.status == 200) {
            this.getAll({});
          }
          
        }
      },
      showEditLine($e) {
        this.onEditRMAPart = $e;
        this.$bvModal.show(this.modalId);
      },
    },
    watch: {
      vrmasList() {
        //This function sets the first row as the selected row
        this.selectedRowItemId = this.setSelectedRowId(this.vrmasList, this.selectedRowItemId, this.lastOpenedId);
      },
    },
    async mounted() {
      if ('clear' in this.$route.query) {
        this.pageInfo.pageNumber = 1;
        this.clearFilter(false);
        this.clearRoute();
      } else {
        if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter){
          this.clearObject(this.filters);
        }

        if('needsAuthorization' in this.$route.params && this.$route.params.needsAuthorization) {
          this.filters.needsAuthorization = true;
          delete this.$route.params.needsAuthorization;
        }

        if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter) {
          this.search(this.filters);
          delete this.$route.params.statisticFilter;
        }else {
          this.setItem({
            resource: 'pageInfo',
            payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
          });
          await this.getAll({});
        }
        this.getSalesReps();
      }
    },
    beforeDestroy() {
      //this.select({ id: null, isChecked: false });
    },
  };
</script>
